import gql from "graphql-tag";
import moment from "moment";
import qs from "query-string";


export type Contract = {
    id: string
    number: string
    group: string
}


export type Cargo = {
    id: string
    code: string
    name: string
    description: string
    type: string
    label?: string
    status: string
    arrival: {
        date?: string
        document: {
            date: string
            number: string
            type: string
        }
    }
    departure: {
        date?: string
        document: {
            date: string
            number: string
            type: string
        }
    }
    tags: {
        agentRelease: boolean
        customsControl: boolean
        terminalRelease: boolean
    }
    container?: {
        number: string
        type: string
        empty: boolean
    }
}

export type TerminalReleaseState =
    "Новая" |
    "Проверки пройдены" |
    "Проверки не пройдены" |
    "ТД Присвоены" |
    "Закрыта" |
    "Отозвана клиентом" |
    "Отклонена сервисным центром" |
    "Подготовка Коммерческого Акта" |
    "К закрытию"


export const TerminalReleaseStatusList: TerminalReleaseState[] = [
    "Новая",
    "Проверки пройдены",
    "Проверки не пройдены",
    "ТД Присвоены",
    "Закрыта",
    "Отозвана клиентом",
    "Отклонена сервисным центром",
    "Подготовка Коммерческого Акта",
    "К закрытию"
]


export type TerminalRelease = {
    DocumentID: string
    Date: string
    Number: string
    Cargo: string
    State: TerminalReleaseState
    Forwarder: string
    Contract: {
        ID: string
        Number: string
        Group: string
    }
    CommercialReleaseDate: string
    PortResponsible: string
    PortComment: string
    ArrivalDocument: string
    IncomingFront: string
    OutgoingFront: string
    IsImport: boolean
    IsExport: boolean
    IsCFS: boolean
    IsCustomControl: boolean
    IsDirectToTSW: boolean
    CheckList: {
        CheckName: string
        CheckResult: boolean
        CheckComment: string
    }[]
}


export type TerminalReleaseShort = {
    id: string
    date: string
    number: string
    cargoInfo: string
    status: TerminalReleaseState
};


export const GetContractListDocument = gql`
    query GetContracts {
        terminalReleaseContracts @rest(path: "remote/erp/api/v2/contracts?active") {
                contracts {
                    id
                    number
                    group
                }
        }
    }
`;
export type GetContractListQueryVars = {}
export type GetContractListQueryResult = {
    terminalReleaseContracts: {
        contracts: Contract[]
    }
}


export const GetCargoListDocument = gql`
    query GetCargos($query: String, $type: String, $page: String, $empty: Boolean, $excludeCodes: [String!]) {
        terminalReleaseCargos(query: $query, type: $type, page: $page, empty: $empty, exclude_codes: $excludeCodes) 
        @rest(pathBuilder: $pathBuilder) {
            cargos @type(name: "TerminalReleaseCargo") {
                id
                code
                name
                description
                status
                type
                label
                arrival {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                departure {
                    date
                    document {
                        date
                        number
                        type
                    }
                }
                container {
                    number
                    type
                    weight
                    empty
                }
                tags {
                    agentRelease
                    customsControl
                    terminalRelease
                }
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`
export function getCargoListPathBuilder({args}) {
    const url = "remote/erp/api/v2/cargos";
    const params = {
        purpose: "terminal-release",
        offset: "20",
    };
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.type) {
        params["type"] = Array.isArray(args.type) ? args.type.join(",") : args.type;
    }
    if (args.page) {
        params["page"] = args.page;
    }
    if (args.empty != null) {
        params["empty"] = args.empty;
    }
    if (args.exclude_codes?.length) {
        params["exclude-cargo"] = args.exclude_codes.join(",");
    }
    return url + "?" + qs.stringify(params);
}
export type GetCargoListQueryVars = {
    type?: string[] | string
    empty?: boolean
    page?: string
    query?: string
    excludeCodes?: string[]
    pathBuilder: typeof getCargoListPathBuilder
}
export type GetCargoListQueryResult = {
    terminalReleaseCargos: {
        cargos: Cargo[]
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}


export const GetTerminalReleaseListDocument = gql`
    query GetTerminalReleaseList($dateFrom: Date, $dateTo: Date, $page: String, $query: String, $status: [String!]) {
        terminalReleases(date_from: $dateFrom, date_to: $dateTo, page: $page, query: $query, status: $status)
        @rest(pathBuilder: $pathBuilder) {
            terminalReleases @type(name: "TerminalRelease") {
                id
                date
                number
                cargoInfo
                status
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`;
export function terminalReleaseListPathBuilder({args}) {
    const url = "remote/erp/api/v2/terminal-releases";
    const params = {
        offset: "20",
    };
    const format = "YYYY-MM-DDTHH:mm:ss";
    if (args.date_from) {
        params["date-from"] = moment(args.date_from).format(format);
    }
    if (args.date_to) {
        params["date-to"] = moment(args.date_to).format(format);
    }
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.status) {
        params["status"] = Array.isArray(args.status) ? args.status.join(",") : args.status;
    }
    if (args.page) {
        params["page"] = args.page;
    }
    return url + "?" + qs.stringify(params);
}
export type GetTerminalReleaseListVars = {
    page?: string
    dateFrom?: number
    dateTo?: number
    query?: string
    status?: string | string[]
    pathBuilder: typeof terminalReleaseListPathBuilder
}
export type GetTerminalReleaseListResult = {
    terminalReleases: {
        terminalReleases: TerminalReleaseShort[]
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}


export const GetTerminalReleaseDocument = gql`
    query GetTerminalRelease($DocumentID: String!) {
        terminalRelease(id: $DocumentID) @rest(path: "remote/erp/VMTP_API/TerminalRelease/v1/{args.id}/get", type: "TerminalRelease") {
            id: DocumentID 
            DocumentID
            Date
            Number
            Cargo
            State
            Forwarder
            Contract {
                ID
                Number
                Group
            }
            CommercialReleaseDate
            PortResponsible
            PortComment
            ArrivalDocument
            IncomingFront
            OutgoingFront
            IsImport
            IsExport
            IsCFS
            IsCustomControl
            IsDirectToTSW
            CheckList {
                CheckName
                CheckResult
                CheckComment
            }
        }
    }
`;
export type GetTerminalReleaseVars = {
    DocumentID: TerminalRelease["DocumentID"]
}
export type GetTerminalReleaseResult = {
    terminalRelease: TerminalRelease
};


export const CreateTerminalReleaseDocument = gql`
    mutation CreateTerminalRelease($input: CreateTerminalReleaseInput!) {
        CreateTerminalRelease(input: $input) @rest(path: "remote/erp/VMTP_API/TerminalRelease/v1", method: "POST") {
            terminal_release {
                code
                message
                container
                doc_uuid
            }
        }
    }
`;
export type CreateTerminalReleaseVars = {
    input: {
        terminal_release: {
            contract_number: Contract["number"]
            container: Cargo["id"]
            date_of_commercial_release: string
        }[]
    }
}
export type CreateTerminalReleaseResult = {
    CreateTerminalRelease: {
        terminal_release: {
            code: 0 | 1 | 2
            message: string
            container: string
            doc_uuid?: string
        }[]
    }
}


export const CancelTerminalReleaseDocument = gql`
    mutation CancelTerminalRelease($DocumentID: String!, $input: CancelTerminalReleaseInput!) {
        cancelTerminalRelease(id: $DocumentID, input: $input) @rest(path: "remote/erp/VMTP_API/TerminalRelease/v1/{args.id}/delete", method: "POST", type: "TerminalRelease") {
            id: DocumentID
            DocumentID
            Date
            Number
            Cargo
            State
            Forwarder
            Contract {
                ID
                Number
                Group
            }
            CommercialReleaseDate
            PortResponsible
            PortComment
            ArrivalDocument
            IncomingFront
            OutgoingFront
            IsImport
            IsExport
            IsCFS
            IsCustomControl
            IsDirectToTSW
            CheckList {
                CheckName
                CheckResult
                CheckComment
            }
        }
    }
`;
export type CancelTerminalReleaseVars = {
    DocumentID: TerminalRelease["DocumentID"]
    input: any
}
export type CancelTerminalReleaseResult = {
    cancelTerminalRelease: TerminalRelease
}


export const RecoveryTerminalReleaseDocument = gql`
    mutation RecoveryTerminalRelease($DocumentID: String!, $input: RecoveryTerminalReleaseInput!) {
        recoveryTerminalRelease(id: $DocumentID, input: $input) @rest(path: "remote/erp/VMTP_API/TerminalRelease/v1/{args.id}}/recovery", method: "POST", type: "TerminalRelease") {
            id: DocumentID
            DocumentID
            Date
            Number
            Cargo
            State
            Forwarder
            Contract {
                ID
                Number
                Group
            }
            CommercialReleaseDate
            PortResponsible
            PortComment
            ArrivalDocument
            IncomingFront
            OutgoingFront
            IsImport
            IsExport
            IsCFS
            IsCustomControl
            IsDirectToTSW
            CheckList {
                CheckName
                CheckResult
                CheckComment
            }
        }
    }
`;
export type RecoveryTerminalReleaseVars = {
    DocumentID: TerminalRelease["DocumentID"]
    input: any
}
export type RecoveryTerminalReleaseResult = {
    recoveryTerminalRelease: TerminalRelease
}
